/* css */
import 'material-design-icons-iconfont'
import 'roboto-fontface'
import 'vue-material/dist/vue-material.css'

/* libraries */
import Vue from 'vue'
import VueMaterial from 'vue-material'
import Vuex, { Store } from 'vuex'
import _ from 'lodash'
import App from './App'
import { rewards } from './rewards'
import { Storage } from './Storage'

Vue.use(VueMaterial)
Vue.use(Vuex)
Vue.config.productionTip = false

Vue.material.registerTheme({
  default: {
    primary: 'indigo',
    accent: 'pink'
  },
  green: {
    primary: 'light-green',
    accent: 'red'
  }
})

const initEma = 0
const initWants = Array(rewards.length).fill(true)
const initExchanged = Array(rewards.length).fill(0)

const currentEma = Storage.get('ema', initEma)
const wants = Storage.get('wants', initWants)
const exchanged = Storage.get('exchanged', initExchanged)

const store = new Store({
  state: {
    rewards,
    wants,
    exchanged,
    currentEma
  },
  getters: {
    getWant (state, getters) {
      return index => state.wants[index]
    },
    getReward (state, getters) {
      return index => state.rewards[index]
    },
    getExchanged (state, getters) {
      return index => state.exchanged[index]
    },
    getAppData (state) {
      return _.zip(state.rewards, state.exchanged, state.wants)
        .map(arr => ({
          rewards: arr[0],
          exchanged: arr[1],
          wants: arr[2]
        }))
    }
  },
  mutations: {
    updateEma (state, value) {
      state.currentEma = value
      Storage.set('ema', state.currentEma)
    },
    updateWant (state, [index, value]) {
      Vue.set(state.wants, index, value)
      Storage.set('wants', state.wants)
    },
    updateExchanged (state, [index, value]) {
      Vue.set(state.exchanged, index, value)
      Storage.set('exchanged', state.exchanged)
    },
    reset (state) {
      Storage.set('ema', initEma)
      Storage.set('wants', initWants)
      Storage.set('exchanged', initExchanged)
      setTimeout(() => {
        location.reload()
      }, 500)
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  store
})



// WEBPACK FOOTER //
// ./src/main.js